import React ,{ useRef } from 'react';
import DeleteAction from 'components/DeleteAction';

const DraggableComponent=(props)=>{
  const { setSteps,steps,loading } = props;
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);

  const dragStart = (e, position) => {
    dragItem.current = position;
  };
 
  const dragEnter = (e, position) => {
    dragOverItem.current = position;
  };

  const drop = (e) => {
    const copyListItems = [...steps];
    const dc=dragItem.current || 0;
    const dragItemContent = copyListItems[dc];
    copyListItems.splice(dc, 1);
    const doc=dragOverItem.current || 0;
    copyListItems.splice(doc, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setSteps(copyListItems);
  };

  const handleStepEdit=(i,value)=>{
    steps[i]=value;
    setSteps([...steps]);
  };

  const handleStepRemove = (i) => {
    steps.splice(i, 1);
    setSteps([...steps]);
  };

  return (
    steps && steps.map((step,index) => {
      return (
        <div  
          onDragStart={(e) => dragStart(e, index)}
          onDragEnter={(e) => dragEnter(e, index)}
          onDragEnd={drop}
          key={index}
          draggable
        >
          <ul className='list-group'>
            <li className='d-flex justify-content-between mb-2'>
              <textarea
                className={'form-control'}
                disabled={loading}
                value={step}
                onChange={(e) => handleStepEdit(index,e.target.value)}
                style={{ cursor:'move' }}
              />
              <DeleteAction loading={false} onClick={() => handleStepRemove(index)} />
            </li>
          </ul>
        </div>
      );
    })
  );
};

export default DraggableComponent;